<template>
    <el-dialog
        width="600px"
        title="指南编辑"
        class="add-guide-dialog"
        :visible.sync="dialogStatus"
        :before-close="handleClose"
        :close-on-click-modal="false">
        <el-form ref="ruleForm" :model="formData" :rules="rules" label-width="100px">
            <el-form-item label="指南名称" prop="guideName">
                <el-input v-model.trim="formData.guideName" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="描述">
                <el-input v-model.trim="formData.description" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="上传文件" prop="downUrl">
                <el-input v-model="formData.downUrl" readonly>
                    <template slot="append">
                        <span class="upload-file-text" @click="uploadFile" >选择文件</span>
                    </template>
                </el-input>
                <el-upload
                    ref="upload"
                    action=""
                    class="upload-add-guide-dialog-switch"
                    :http-request="submitUpload"
                    accept="application/pdf"
                    :show-file-list="false"
                    :auto-upload="true">
                </el-upload>
            </el-form-item>
            <el-form-item label="状态">
                <el-switch
                    :active-text="$translate('lang.E3202102260004', { defaultText: '启用' })"
                    :inactive-text="$translate('lang.E3202102260003', { defaultText: '停用' })"
                    class="add-guide-dialog-switch"
                    v-model="formData.status"
                    active-value="Y"
                    inactive-value="N"
                ></el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="save" :loading="saveLoading" >确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { uploadPictures } from '../../../api/product';
export default {
    props: {
        dialogVisible: Boolean,
        saveLoading: Boolean,
        ruleForm: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        dialogStatus: {
            set(val) {
                this.$emit(`update:dialogVisible`, val);
            },
            get() {
                return this.dialogVisible;
            }
        }
    },
    data() {
        return {
            formData: {},
            rules: {
                guideName: [{ required: true, message: '请输入指南名称', trigger: 'blur' }],
                downUrl: [{ required: true, message: '请上传操作指南', trigger: 'blur' }]
            }
        };
    },
    methods: {
        handleClose() {
            this.dialogStatus = false;
        },
        save() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const data = JSON.parse(JSON.stringify(this.formData));
                    this.$emit('saveData', data);
                }
            });
        },
        submitUpload(uploadData) {
            this.$set(this.formData, 'downUrl', '');
            if (!uploadData || uploadData.file.type !== 'application/pdf') {
                this.$message.warning('文件上传类型不正确');
                this.$refs.upload.clearFiles();
                return;
            }
            const form = new FormData();
            form.append('file', uploadData.file);
            this.$message.success('文件上传中，请不要关闭页面');
            uploadPictures(form).then(res => {
                if (res && res.code === '0') {
                    this.formData.downUrl = res.data.downUrl;
                    this.$message.success('文件上传成功');
                }
            }).finally(() => {
                this.$refs.upload.clearFiles();
            });
        },
        uploadFile() {
            this.$refs['upload'].$children[0].$refs.input.click();
        }
    },
    watch: {
        dialogVisible(newv, oldv) {
            if (newv) {
                this.formData = JSON.parse(JSON.stringify(this.ruleForm));
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            }
        }
    }
};
</script>
<style lang="less">
.add-guide-dialog{
    .el-input-group__append {
        padding: 0;
    }
    .upload-file-text{
        padding:6px 20px;
        cursor: pointer;
    }
    .upload-add-guide-dialog-switch{
        display: none;
    }
    .el-switch .el-switch__core,
    .el-switch .el-switch__label {
        width: 56px !important;
    }
}
.add-guide-dialog-switch{
    .el-switch__label {
        position: absolute;
        display: none;
        color: #fff;
    }
    .el-switch__label--right {
        z-index: 1;
        right: -5px;
        top: 2px;
    }
    .el-switch__label--left {
        z-index: 1;
        left: 25px;
        top: 2px;
    }
    .el-switch__label.is-active {
        display: block;
    }
}

</style>